import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Input, message } from "antd";

const CHARACTER_LIMIT = 100;
const ERROR_MESSAGE_MAX = "Maximum character limit reached!";
export const TextInput = (props) => {
  useEffect(() => {
    props.wordCharacterCount &&
      props.wordCharacterCount({ target: { value: props.value } });
  }, [props.value]);
  const inputChange = (eve) => {
    let limit = props.maxLength || CHARACTER_LIMIT;
    if (eve.target.value.length > limit) {
      message.error(props.maxLimitMessage || ERROR_MESSAGE_MAX);
    } else {
      props.onChange && props.onChange(eve);
      props.wordCharacterCount && props.wordCharacterCount(eve);
    }
  };

  return (
    <Input
      onChange={inputChange}
      disabled={props.disabled}
      placeholder={
        props.hidePlaceHolder ? undefined : props.placeholder || props.title
      }
      defaultValue={props.defaultValue}
      allowClear={props.allowClear}
      value={props.value}
      type={props.htmlType}
      name={props.name}
      autoFocus={props.autoFocus}
      onFocus={props.onFocus}
      autoComplete='off'
      key={props.key}
      onKeyDown={props.onKeyDown}
      onPressEnter={props.onPressEnter}
      onClick={props.onClick}
      id={props.id}
      max={props.max}
      min={props.min}
      //maxLength={props.maxLength || CHARACTER_LIMIT} // maxLength is used to limit the maximum Length
      onBlur={props.onBlur}
      style={props.style}
      className={`${props.className || ""} ${!props.isValid ? " error-field" : ""
        }`}
    />
  );
};
TextInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  index: PropTypes.number,
  disabled: PropTypes.bool,
  placeHolder: PropTypes.string,
  value: PropTypes.any,
  htmlType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isValid: PropTypes.bool,
};
